"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _constants = require("../constants");
// text field

const styleOverrides = {
  root: {
    borderRadius: 5,
    [`&.${_material.outlinedInputClasses.multiline} .${_material.inputAdornmentClasses.root}`]: {
      alignSelf: 'flex-start',
      marginTop: 16,
      marginRight: 4,
      marginLeft: 4
    }
  },
  inputSizeSmall: {
    padding: '8.5px 14px'
  },
  adornedStart: {
    [`& .${_material.outlinedInputClasses.input}`]: {
      paddingLeft: 0
    }
  },
  adornedEnd: {
    [`& .${_material.outlinedInputClasses.input}`]: {
      paddingRight: 0
    }
  },
  notchedOutline: {
    background: 'unset',
    borderColor: _constants.textInputData.border.color,
    '& legend': {
      position: 'unset'
    }
  },
  multiline: {
    padding: 15
  }
};
const defaultProps = {
  color: 'inputElements'
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
